<template>
    <header>
        <div class="container">
            <div class="row align-items-center">
                <div class="col col-xl-2 order-2 order-xl-1">
                    <router-link :to="{ name: 'Home' }"
                        ><img src="/img/logo.svg" class="logo" />
                    </router-link>
                </div>
                <div class="col-3 col-xl-7 order-1 order-xl-2">
                    <div class="menu-open d-flex d-xl-none">
                        <img src="/img/menu.svg" />
                    </div>
                    <div class="menu-close d-none">X</div>
                    <ul class="navigation text-center" id="main-menu">
                        <template v-for="(item, index) in menu.items">
                            <li v-bind:key="'felso-menu-' + index">
                                <router-link :to="item.link">{{
                                    item.title
                                }}</router-link>
                            </li>
                        </template>
                    </ul>
                </div>
                <div class="col-auto col-xl-3 order-3">
                    <ul class="navigation">
                        <li class="position-relative" ref="langMenu">
                            <LanguageSwitcher
                                :open="openPanel === 'lang'"
                                v-on:toggle="togglePanel('lang')"
                                v-on:close="openPanel = null"
                            />
                        </li>
                        <li class="position-relative" ref="profileMenu">
                            <ProfileMenu
                                :open="openPanel === 'profile'"
                                v-on:toggle="togglePanel('profile')"
                                v-on:close="openPanel = null"
                            />
                        </li>
                        <li class="position-relative">
                            <button
                                type="button"
                                ref="cartToggle"
                                class="header-cart-toggle d-flex align-items-center"
                                :aria-expanded="
                                    openPanel === 'cart' ? 'true' : 'false'
                                "
                                v-on:click="togglePanel('cart')"
                            >
                                <img
                                    src="/img/shopping-cart-solid.svg"
                                    class="menu-icon d-inline-flex d-xl-none"
                                    alt=""
                                />
                                <span class="d-none d-xl-block">{{
                                    $t("Kosár")
                                }}</span>
                                <strong
                                    class="text-orange ms-2"
                                    v-if="cartItems > 0"
                                    >{{ cartItems }}</strong
                                >
                            </button>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <CartSidebar
            :open="openPanel === 'cart'"
            :cart="cart"
            v-on:close="closeCart"
        />
    </header>
</template>

<script>
import ProfileMenu from "./ProfileMenu";
import LanguageSwitcher from "./LanguageSwitcher";
import CartSidebar from "./cart/CartSidebar";

export default {
    name: "Header",
    data() {
        return {
            menu: [],
            openPanel: null,
            cart: {
                items: []
            }
        };
    },
    components: { ProfileMenu, CartSidebar, LanguageSwitcher },
    computed: {
        url: function() {
            return `${process.env.VUE_APP_API_URL}`;
        },
        isAuthenticated() {
            return this.$store.getters.isAuthenticated;
        },
        cartItems: function() {
            if (this.cart && this.cart.items) {
                return this.cart.items.length;
            }
            return 0;
        }
    },
    watch: {
        isAuthenticated() {
            this.getCart();
        },
        $route: {
            handler: function() {
                this.openPanel = null;
            },
            deep: true
        }
    },
    methods: {
        getMenu() {
            this.$http.get(`${this.url}/menu/get/1`).then(response => {
                this.menu = response.data.data;
            });
        },
        getCart() {
            const cartUUid = localStorage.getItem("cart_uuid");
            const path = this.isAuthenticated ? "cart/auth" : "cart";
            this.$http.get(`${this.url}/${path}/${cartUUid}`).then(response => {
                localStorage.setItem("cart_uuid", response.data.data.uuid);
                this.cart = response.data.data;
            });
        },
        togglePanel(name) {
            this.openPanel = this.openPanel === name ? null : name;
        },
        closeCart() {
            this.openPanel = null;
            this.$nextTick(() => {
                if (this.$refs.cartToggle) {
                    this.$refs.cartToggle.focus();
                }
            });
        },
        onDocumentClick(event) {
            const refs = { profile: "profileMenu", lang: "langMenu" };
            const menu = this.$refs[refs[this.openPanel]];
            if (
                menu &&
                !menu.contains(event.target) &&
                !event.target.closest(".modal")
            ) {
                this.openPanel = null;
            }
        },
        onKeydown(event) {
            if (event.key === "Escape" && this.openPanel) {
                if (this.openPanel === "cart") {
                    this.closeCart();
                } else {
                    this.openPanel = null;
                }
            }
        },
        onOpenCart() {
            this.openPanel = "cart";
        },
        onUpdateCart() {
            this.getCart();
        }
    },
    beforeMount() {
        this.getMenu();
        this.getCart();
        this.$eventHub.$on("updateCart", this.onUpdateCart);
        this.$eventHub.$on("openCart", this.onOpenCart);
    },
    mounted() {
        document.addEventListener("click", this.onDocumentClick);
        document.addEventListener("keydown", this.onKeydown);
        $(document).ready(function() {
            $(document).on("click", ".menu-open", function() {
                $(this).toggleClass("active");
                $("#main-menu").toggleClass("active");
                $(".menu-close").toggleClass("d-none");
            });

            $(document).on("click", ".menu-close", function() {
                $(".menu-open").toggleClass("active");
                $("#main-menu").toggleClass("active");
                $(".menu-close").toggleClass("d-none");
            });
            $(document).on("click", ".navigation a", function() {
                $(".menu-open").removeClass("active");
                $("#main-menu").removeClass("active");
                $(".menu-close").addClass("d-none");
            });
        });
    },
    beforeDestroy() {
        document.removeEventListener("click", this.onDocumentClick);
        document.removeEventListener("keydown", this.onKeydown);
        this.$eventHub.$off("updateCart", this.onUpdateCart);
        this.$eventHub.$off("openCart", this.onOpenCart);
    }
};
</script>

<style>
.header-cart-toggle {
    background: none;
    border: 0;
    padding: 0;
    color: inherit;
    font: inherit;
    text-transform: inherit;
    cursor: pointer;
}
</style>
